import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';

/** Manual fallback for Rx bottles too large for the scanner rig: the operator
 *  types the printed Rx number, which then goes through the same POM
 *  validation as a scanned bottle. */
const ManualRxDialog = ({ open, onClose, onSubmit }) => {
  const [rxNumber, setRxNumber] = useState('');

  const handleClose = () => {
    setRxNumber('');
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const value = rxNumber.trim();
    if (!value) return;
    onSubmit(value);
    setRxNumber('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby='manual-rx-title' fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle id='manual-rx-title'>Enter Rx number manually</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            For bottles that don&apos;t fit the scanner rig — enter the printed Rx number and it
            will be validated the same way as a scan.
          </DialogContentText>
          <TextField
            autoFocus
            fullWidth
            size='small'
            label='Rx Number'
            value={rxNumber}
            onChange={(e) => setRxNumber(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='inherit'>
            Cancel
          </Button>
          <Button type='submit' variant='contained' disabled={!rxNumber.trim()}>
            Start session
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

ManualRxDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ManualRxDialog;
